import { RelatedEntityComponentProps } from '@unistocks/features/notifications/related-entities/related-entity-component-props';
import { TransactionNotificationData } from '@unistocks/features/notifications/related-entities/transaction';

export const getRelatedEntityComponent = (entityName: string) => {
  let Component: React.ComponentType<RelatedEntityComponentProps> | undefined;

  switch (entityName) {
    case 'Transaction':
      Component = TransactionNotificationData;
      break;
  }

  return Component;
};
